export default __webpack_public_path__ + "static/media/Ballroll_00156.649d048e.png";